/* ────────────────────────────────────────────────────────────────────────
   EF SCREEN STUDIO (2026-06-01, v2 — real 3D)
   Loaded only on screen PDPs that have a real GLB model (gated in
   product.fireplace-doors.liquid). It recolors the <model-viewer> frame
   (#efScreenStudioMV) to the finish the customer picks, by sampling the
   selected swatch image and applying it via model-viewer's material API.
   Read-only against the configurator — never touches selections/cart.
   No SVG, no fake geometry: if there's no GLB, this file isn't loaded.
   ──────────────────────────────────────────────────────────────────────── */
(function () {
  'use strict';
  var _rgb = null, _raf = 0;

  function $(s, c) { return (c || document).querySelector(s); }

  /* dominant colour of the currently-selected finish swatch */
  function selectedSwatchColor(cb) {
    var sw = $('.ef-cfg-swatch[aria-checked="true"] .ef-cfg-swatch__circle')
          || $('.ef-cfg-swatch[aria-checked="true"]');
    var bg = sw && getComputedStyle(sw).backgroundImage;
    var u = bg && bg.match(/url\(["']?(.*?)["']?\)/);
    if (!u || !u[1]) { cb(null); return; }
    var img = new Image();
    img.crossOrigin = 'anonymous';
    img.onload = function () {
      try {
        var c = document.createElement('canvas'); c.width = c.height = 8;
        var x = c.getContext('2d'); x.drawImage(img, 0, 0, 8, 8);
        var d = x.getImageData(3, 3, 2, 2).data;
        cb([d[0] / 255, d[1] / 255, d[2] / 255]);
      } catch (e) { cb(null); }
    };
    img.onerror = function () { cb(null); };
    img.src = u[1];
  }

  /* Door GLBs include a transparent GLASS panel and sometimes a single UNNAMED
     catch-all material covering the whole model (e.g. Milwaukee). Tinting either
     would turn the glass opaque or paint the entire door one flat colour. Only the
     named metal frame parts should follow the finish. Screen GLBs use named metal
     materials (Black_metal/Allum), so these guards are no-ops for screens. */
  function isGlassMat(m) { var n = (m && m.name || '').toLowerCase(); return n.indexOf('glass') !== -1 || n.indexOf('crystal') !== -1 || n.indexOf('lens') !== -1; }
  function isPaintable(m) { return !!(m && m.name) && !isMeshMat(m) && !isGlassMat(m); }

  function recolor(mv, rgb) {
    try {
      if (!mv.model || !mv.model.materials) return;
      mv.model.materials.forEach(function (m) {
        if (!m.pbrMetallicRoughness) return;
        if (!isPaintable(m)) return; /* skip mesh, glass and unnamed catch-all materials */
        m.pbrMetallicRoughness.setBaseColorFactor([rgb[0], rgb[1], rgb[2], 1]);
      });
    } catch (e) {}
  }

  /* The mesh material ("Net") is a flat quad with an RGBA mesh texture — thin opaque
     wires over transparent holes (BLEND). At viewing distance that reads ~85% open, so
     the screen centre looks empty against the bright/fire background. We DROP the alpha
     mesh texture and pin a uniform dark translucent steel so the screen is clearly
     visible while the fire still shows through it. Fallback (if setTexture is unavailable):
     darkening the factor still makes the wires visible. */
  function isMeshMat(m) { var n = (m && m.name || '').toLowerCase(); return n.indexOf('net') !== -1 || n.indexOf('mesh') !== -1; }
  /* Door GLBs ship the GLASS panel as a very transparent dark BLEND material
     (alpha ~0.4). With no fire behind it in the studio that reads as empty — the
     glass is invisible. Raise the opacity (keep the tint) so the panel is clearly
     visible. setBaseColorFactor is reliable at runtime (same call recolor uses).
     Screens have no glass material → no-op. */
  function fixGlass(mv) {
    try {
      if (!mv.model || !mv.model.materials) return false;
      var hit = false;
      mv.model.materials.forEach(function (m) {
        if (!(m.pbrMetallicRoughness && isGlassMat(m))) return;
        hit = true;
        var p = m.pbrMetallicRoughness;
        /* Original glass was near-black (0.05) + matte + alpha 0.4 → invisible on a neutral
           studio env with no fire behind it. Render it as a SMOKY tinted glass panel that's
           clearly lighter than the black frame, mostly opaque, and reflective (low roughness),
           so it reads as glass in both the gallery and studio viewers. */
        try { p.setBaseColorFactor([0.15, 0.16, 0.19, 0.84]); } catch (e) {}
        try { p.setMetallicFactor(0.0); } catch (e) {}
        try { p.setRoughnessFactor(0.10); } catch (e) {}
      });
      return hit;
    } catch (e) { return false; }
  }

  function fixMesh(mv) {
    try {
      if (!mv.model || !mv.model.materials) return false;
      var hit = false;
      mv.model.materials.forEach(function (m) {
        if (!(m.pbrMetallicRoughness && isMeshMat(m))) return;
        hit = true;
        /* The "Net" mesh quad is fixed at the SOURCE now: the GLB ships the Net material
           with alphaMode = OPAQUE so its RGB weave texture (a realistic grey mesh) renders
           solid instead of ~85% transparent holes (runtime alpha/texture overrides proved
           unreliable in Shopify's model-viewer). Here we only RE-ASSERT OPAQUE as a harmless
           belt-and-braces and DON'T touch the colour/texture, so the real grey weave shows. */
        try { if (m.setAlphaMode) m.setAlphaMode('OPAQUE'); } catch (e) {}
        try { if (m.setDoubleSided) m.setDoubleSided(true); } catch (e) {}
      });
      return hit;
    } catch (e) { return false; }
  }

  /* ALL <model-viewer> instances on the page — the prominent GALLERY model-viewer AND the
     studio one. The earlier version only touched #efScreenStudioMV, so the gallery 3D (the
     big one customers actually look at) kept the invisible glass/mesh. */
  function viewers() {
    var list = [];
    try { document.querySelectorAll('model-viewer').forEach(function (m) { list.push(m); }); } catch (e) {}
    return list;
  }

  /* Mesh + glass visibility — independent of any finish selection. */
  function fixVisibility(mv) { fixMesh(mv); fixGlass(mv); }

  function apply() {
    selectedSwatchColor(function (rgb) {
      if (!rgb) return;
      _rgb = rgb;
      viewers().forEach(function (mv) {
        if (mv.model && mv.model.materials) recolor(mv, rgb);
        else mv.addEventListener('load', function once() { mv.removeEventListener('load', once); if (_rgb) recolor(mv, _rgb); });
      });
    });
  }

  function schedule() { if (_raf) return; _raf = requestAnimationFrame(function () { _raf = 0; apply(); }); }

  function init() {
    var vs = viewers();
    if (!vs.length) return;
    /* re-apply finish recolor whenever a finish (or finish tab) is touched */
    document.addEventListener('click', function (e) {
      if (e.target.closest && e.target.closest('.ef-cfg-swatch, .ef-cfg-tab')) schedule();
    }, true);
    var root = $('[data-cfg-type]');
    if (root && window.MutationObserver) {
      new MutationObserver(schedule).observe(root, { attributes: true, subtree: true, attributeFilter: ['aria-checked'] });
    }
    /* Materials can populate slightly after 'load' fires, so retry a few times PER viewer. */
    function retry(mv) { [0, 300, 900, 1800, 3000].forEach(function (d) { setTimeout(function () { fixVisibility(mv); }, d); }); }
    vs.forEach(function (mv) {
      mv.addEventListener('load', function () { retry(mv); schedule(); });
      if (mv.model) retry(mv);
    });
    schedule();
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
